export default {
  "HitPaw Online Audio Joiner": "HitPaw Online Audio Joiner",
  "Merge Audio": "Unisce audio",
  "Merge multiple audio tracks into one.": "Unisce più tracce audio in una.",
  "Merge New": "Unisce un nuovo",
  "Merge failed": "Unione non riuscita",
  "Fade in": "Dissolvenza in entrata",
  "Fade out": "Dissolvenza in uscita",
  "Add tracks": "Aggiungere tracce",
  "Format": "Formato",
};
